import React from "react";

import { ColumnStyle, Steward } from "components/Common/TableStyle";

export const REFERENCE_SOURCES_COLUMNS = () => [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    fixed: "left",
    width: 150,
    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    width: 300,
    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "reference_source_type",
    key: "reference_source_type",
    title: "Type",
    width: 150,
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    render: text => <Steward name={text?.name} title={text?.role} />,
    width: 200,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    render: text => <Steward name={text?.name} title={text?.role} />,
    width: 200,
  },
];
